export enum QuotationType {
  CAR= 'CAR_ONLY',
  CAR_AND_HOME= 'CAR_AND_HOME'
}
